import Vue from "vue";
import Router from "vue-router";
import VueSession from "vue-session";
import LinkBuilding from "@/components/templates/LinkBuilding";
import AdversimentsDashboard from "@/components/templates/AdversimentsDashboard";
import SeoDashboard from "@/components/templates/SeoDashboard";
import FileManagement from "@/components/templates/FileManagement";
import Checkout from "@/components/templates/Checkout";
import ConfigurarDominio from "@/components/templates/ConfigurarDominio";
import Dashboard from "@/components/Dashboard";
import DashboardHome from "@/components/templates/DashboardHome";
import DashboardPaymentMessage from "@/components/templates/DashboardPaymentMessage";
import LinkManagement from "@/components/organisms/ExternalLinkManagement";
import StoreManagement from "@/components/organisms/StoreManagement";
import Login from "@/components/Login";
import LoginApplication from "@/components/templates/LoginApplication";
import LoginSocialMedia from "@/components/LoginSocialMedia";
import MediaManager from "@/components/organisms/MediaManager";
import NewPost from "@/components/NewPost";
import Privacidade from "@/components/Privacidade";
import Post from "@/components/templates/Post";
import PostEditor from "@/components/templates/PostEditor";
import PostEditorImporter from "@/components/templates/PostEditorImporter";
import RecoveryPassword from "@/components/templates/RecoveryPassword";
import RedirectManager from "@/components/templates/RedirectManager";
import RedirectToDashboard from "@/components/RedirectToDashboard";
import ResetPassword from "@/components/templates/ResetPassword";
import Signin from "@/components/Signin";
import StepWizard from "@/components/templates/StepWizard";
import StepWizardHandler from "@/components/organisms/StepWizardHandler";
import TermosDeUso from "@/components/TermosDeUso";
import UserPanel from "@/components/UserPanel";
import Wizard2 from "@/components/templates/Wizard";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

var options = {
	persist: true
}

Vue.use(Router);
Vue.use(VueSession, options);

export default new Router({
	mode: "history",
	routes: [
		{
			path: "/",
			name: "Home",
			component: Login,
		},
		{
			path: "/wizard2",
			component: Wizard2,
			props: true,
			children: [
				{
					path: "step",
					component: StepWizard,
					children: [
						{
							path: ':stepWizard',
							name: 'StepWizard',
							component: StepWizardHandler,
							props: true
						}
					]
				}
			]
		},
		{
			path: "/dashboard",
			component: Dashboard,
			children: [
				{
					path: '',
					component: DashboardHome
				},
				{
					path: 'publicidades',
					component: AdversimentsDashboard
				},
				{
					path: 'seo',
					name: 'seo',
					component: SeoDashboard
				},
				{
					path: 'linkBuilding',
					component: LinkBuilding
				},
				{
					path: "user-dashboard",
					component: RedirectToDashboard
				},
				{
					name: 'oldEditor',
					path: "oldEditor/new",
					component: NewPost,
				},
				{
					path: "importer",
					component: PostEditorImporter
				},
				{
					path: "link-management",
					component: LinkManagement
				},
				{
					path: "store-management",
					component: StoreManagement
				},
				{
					path: "media-manager",
					component: MediaManager
				},
				{
					path: "redirects",
					component: RedirectManager
				},
				{
					path: "files",
					component: FileManagement
				},
				{
					path: "post",
					component: Post,
					props: true,
					children: [
						{
							path: ':postId/edit',
							name: 'PostEditor',
							component: PostEditor,
							props: true
						}
					]
				},
				{
					path: 'payment_alert',
					name: "PaymentAlert",
					component: DashboardPaymentMessage
				},
			]
		},
		{
			path: "/login",
			name: "Login",
			component: Login
		},
		{
			path: "/login/application",
			name: "LoginApplication",
			component: LoginApplication
		},
		{
			path: "/signin",
			name: "Signin",
			component: Signin
		},
		{
			path: "/panel",
			name: "UserPanel",
			component: UserPanel
		},

		{
			path: "/checkout",
			name: "Checkout",
			component: Checkout
		},
		{
			path: "/login/social-media/",
			name: "LoginSocialMedia",
			component: LoginSocialMedia
		},
		{
			path: "/termos-de-uso",
			name: "TermosDeUso",
			component: TermosDeUso
		},
		{
			path: "/privacidade",
			name: "Privacidade",
			component: Privacidade
		},
		{
			path: "/faq/configurar-dominio",
			name: "ConfigurarDominio",
			component: ConfigurarDominio
		},
		{
			path: "/recovery-password",
			name: "Recovery",
			component: RecoveryPassword
		},
		{
			path: "/reset-password/",
			name: "Reset",
			component: ResetPassword
		},
		{
			path: "/wizard",
			redirect: "/wizard2/step"
		},
		{
			path: "/registre",
			redirect: "/signin"
		},
		{
			path: "/registrar",
			redirect: "/signin"
		},
		{
			path: "/cadastro",
			redirect: "/signin"
		},
		{
			path: "/entrar",
			redirect: "/login"
		}
	]
});



// WEBPACK FOOTER //
// ./src/router/index.js